import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    // path: '/',
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '/customer',
        name: 'customer',
        component: () => import('../views/customer')
      },
      {
        path: '/course',
        name: 'course',
        component: () => import('../views/course')
      },
      {
        path: '/course_table',
        name: 'course_table',
        component: () => import('../views/course_table')
      },
      {
        path: '/sortAndTag',
        name: 'sortAndTag',
        component: () => import('../views/sortAndTag')
      },
      {
        path: '/hexiao',
        name: 'hexiao',
        component: () => import('../views/hexiao')
      }
      ,
      {
        path: '/activity',
        name: 'activity',
        component: () => import('../views/Activity')
      },
      {
        path: '/activityadd',
        name: 'activityadd',
        component: () => import('../views/Activityadd')
      },
      {
        path: '/icon',
        name: 'icon',
        component: () => import('../views/icon')
      }
    ]
  },

]

const router = new VueRouter({
  mode:"hash",
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') // 获取token
  document.title = '趣帆儿童书店管理后台'; 
  if (to.path !== '/login' && !token) {
    // 如果目标路由不是登录页且没有token，则重定向到登录页
    next('/login')
  } else {
    // 否则，继续导航
    next()
  }
})



export default router
